import React, { memo, useState, useCallback, useEffect, useMemo } from 'react'
import ApexCharts from 'apexcharts'

import ChartArea from 'components/ChartArea/ChartArea'
import ArrowDownRightCircle from 'components/CommonUI/svgIcons/ArrowDownRightCircle'
import WeatherControl from './WeatherControl'
import { useShallowEqualSelector } from 'custom-hooks'
import { getDataFacilityConsumptionCharts } from 'redux/reducers/facility'
import Title from 'components/CommonUI/Title/Title'
import Link from 'components/CommonUI/Link/Link'
import { routingConstants } from 'constants/routingConstants'

const chartsConstants = {
  nameTemperatureCharts: '℃',
  chartId: 'facility_consaption_charts',
}

const ConsumptionChart = ({ isFetching, facilityId, selectedDateRange }) => {
  const chartData = useShallowEqualSelector(getDataFacilityConsumptionCharts)

  const [xAxisData, yAxisData, yAxisTemperature] = chartData

  const [checked, setChecked] = useState(true)

  const series = useMemo(
    () => [
      { name: 'kWh', type: 'area', color: '#4AA652', data: yAxisData },
      {
        name: chartsConstants.nameTemperatureCharts,
        type: 'line',
        color: '#E5911C',
        data: yAxisTemperature,
      },
    ],
    [yAxisData, yAxisTemperature]
  )

  const handleChange = useCallback(() => {
    setChecked((prev) => !prev)
  }, [])

  useEffect(() => {
    ApexCharts.exec(chartsConstants.chartId, 'updateSeries', series)

    if (checked) {
      ApexCharts.exec(chartsConstants.chartId, 'showSeries', [
        chartsConstants.nameTemperatureCharts,
      ])
    } else {
      ApexCharts.exec(chartsConstants.chartId, 'hideSeries', [
        chartsConstants.nameTemperatureCharts,
      ])
    }
  }, [checked, series])

  return (
    <div className="consaption_chart_container top_chart">
      <Title title="Consumption" className="title-page" component="h2" />
      <ChartArea
        seriesY={series}
        categoriesX={xAxisData}
        id={chartsConstants.chartId}
        className="facility_consaption_charts"
        isFetching={isFetching}
      />
      <div className="show_details_section">
        <div className="show_detail_button_container">
          <Link
            className="details"
            to={{
              pathname: `${routingConstants.equipment}/${facilityId}`,
              state: { selectedDateRange },
            }}
          >
            <span className="details_title">Show Equipment</span>
            <ArrowDownRightCircle />
          </Link>

        </div>
        <div className="weather-check-holder">
          <WeatherControl
            checked={checked}
            handleClickWeather={handleChange}
            disabled={isFetching}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(ConsumptionChart)
